import { IGroup } from "../../common/group";

export type InitialState = {
    groups: Record<IGroup['id'], IGroup>;
}

export const enum ACTION_TYPES {
    FETCH_GROUPS = 'fetchGroups',
    FETCH_GROUPS_SUCCESS = 'fetchGroupsSuccess',
    ADD_GROUP = 'addGroup',
    EDIT_GROUP = 'editGroup',
    DELETE_GROUP = 'deleteGroup',
    ADD_GROUP_USER = 'addGroupUser',
    DELETE_GROUP_USER = 'deleteGroupUser',
    GET_GROUP_COURSES = 'getGroupCourses',
    GET_GROUP_COURSES_SUCCESS = 'getGroupCoursesSuccess',
    ADD_GROUP_COURSE = 'addGroupCourse',
    DELETE_GROUP_COURSE = 'deleteGroupCourse',
};

export type Actions = {
    type: ACTION_TYPES,
    payload?: any,
};